export const openInvoiceInNewTab = (urlName, id) => {
    window.open(`${process.env.REACT_APP_BACKEND_BASEURL}pdf/${urlName}?number=${id}`, '_blank')
}